exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog__upload[data-v-0a8dc486] .el-step.is-simple .el-step__title{font-size:15px!important}.dialog__upload[data-v-0a8dc486] .el-upload-dragger{height:244px!important;width:490px!important}.dialog__upload[data-v-0a8dc486],.el-dialog__body[data-v-0a8dc486],.small-dialog[data-v-0a8dc486] .el-dialog{height:auto!important}.mt-40px[data-v-0a8dc486]{margin-top:40px}.mb-70px[data-v-0a8dc486]{margin-bottom:70px}", ""]);

// exports
